import { api } from "./axios";

export async function getAllcontactUsMessages() {
    let res = await api.get("contact/getAll");
    if (res) return res.data.data;
    else return false;
}
export async function deleteContactUsMessages(id) {
    let res = await api.get("contact/destroy/" + id);
    if (res) return res.data.data;
    else return false;
}


export async function getAllAdvertises() {
    let res = await api.get("advertises/index");
    if (res) return res.data.data;
    else return false;
}
export async function deleteAdvertises(id) {
    let res = await api.get("advertises/destroy/" + id);
    if (res) return res.data.data;
    else return false;
}


